<template>
  <div class="container-fluid login">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info">
        <div class="logo">
          <a :href="lpUrl" class="ico-iouu" target="_blank" title="IOUU"></a>
        </div>
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-lg-10 d-flex flex-column align-items-center">
          <h1>Recuperar senha</h1>
            <p>
              Não se preocupe. Você não está assumindo nenhum compromisso neste momento.
              <br/>Suas informações serão usadas apenas para analisarmos o seu perfil
            </p>
            <p>
              Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.
            </p>
          </div>        
        </div>
        <social-network/>

      </div>
      <div class="col-12 col-md-12 col-lg-7 d-flex flex-column form">
        <header class="align-self-center align-self-md-end">
          Já tem uma conta?
          <router-link to="login" class="btn btn-outline-primary">Entrar</router-link>
        </header>
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-md-8 col-lg-5 text-center">
            <h2>Perdeu sua senha?</h2>
            <span class="text">Digite seu endereço de e-mail abaixo
para recuperar sua senha.</span>
            <form id="form-recuperar-senha" @submit.prevent="sendResePasswordtEmail">
              <div class="form-group text-left ">
                <label for="email">Endereço de email</label>
                <input type="email" class="form-control form-control-lg" v-model="email" autofocus>
              </div>
              <button class="btn btn-lg btn-primary">Enviar</button>
            </form>
            <router-link to="login" class="btn btn-link">Voltar para entrar</router-link>
          </div>
        </div>
      </div>      
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../assets/styles/iouu/_variables";
  .login {
    .info {
      background:url(/static/assets/images/bg-login.jpg) top center no-repeat, linear-gradient(to bottom right, $c3, $c2 85%);
      background-size: cover;
      // background-blend-mode: multiply;
      text-align: center;
      color: #fff;
    }
  }
</style>

<script>
import ApiClient from '@/utils/api-client'
import ApiClientGo from '../utils/api-client-go'
import SocialNetwork from '@/components/SocialNetwork'
import ArrayHelper from '@/utils/array-helper'

export default {
  data() {
    return {
      lpUrl:process.env.LP_URL,
      email: ''
    }
  },
  components: {
    SocialNetwork
  },
  methods: {
    sendResePasswordtEmail() {
      ApiClientGo.post('send-reset-password-email', {data: {email: this.email}})
        .then(() => {
          this.$Notify.info('Pronto, você vai receber um e-mail com as instruções para recuperar sua senha')
          this.email = ''
        })
        .catch(error => {
          const errorMessages = error.response.data.errors.map(error => error.detail)
          this.$Notify.error(ArrayHelper.toSentence(errorMessages))
        })
    },
    //tagueamento GA
    taggingGA() {
      this.$ga.page({
        page: '/recuperar-senha',
        title: 'Recuperar Senha',
      })
    },
  },
  async created() {
    //tagueamento GA
    await this.taggingGA();
  }
}
</script>



// WEBPACK FOOTER //
// src/views/RecuperarSenha.vue